import Vue from 'vue'
import VueRouter from 'vue-router'

import HomePage from '../views/HomePage.vue'

Vue.use(VueRouter)

const routes = [
      // 路由重新定向
    {
        path: '/index',
        redirect: "/"
    },
    // 首页
    {
        path: '/',
        name: 'HomePage',
        component: HomePage,
    },
    // 关于我们
    {
        path: '/about_us',
        name: 'AboutUsPage',
        component: () => import("@/views/AboutUsPage.vue"),
    },
    // 新闻动态
    {
        path: '/news',
        name: 'NewsPage',
        component: () => import("@/views/NewsPage.vue"),
    },
    // 新闻动态
    {
        path: '/newsDetails',
        name: 'NewsDetailPage',
        component: () => import("@/views/NewsDetailPage.vue"),
    },
    // 产品下载
    {
        path: '/download',
        name: 'DownloadPage',
        component: () => import("@/views/DownloadPage.vue"),
    },
    // 信息大厅
    {
        path: '/information',
        name: 'InformationPage',
        component: () => import("@/views/InformationPage.vue"),
    },
    // 产品下载
    // {
    //     path: '/a',
    //     name: 'aPage',
    //     component: () => import("@/views/aPage.vue"),
    // },
]

const router = new VueRouter({
    // mode: 'hash',
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// meta: {
  //   requiresAuth: true,
  //   content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
// },


const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err);
}

// router.beforeEach((to, from, next) => {
//     const isLogin = localStorage.getItem('isLogin')
//     console.log('路由',to,from);

//     if ( !isLogin ) {
//         next('/') // 未登录则重定向到登录页面
//     } else {
//         next()
//     }
// })

router.afterEach((to, from) => {
  // 在路由切换后滚动到页面顶部
    console.log('路由切换',to.path,from.path);
    if (to.path !== from.path) {
        window.scrollTo(0, 0); // 将滚动条位置设置到页面最顶部
    }
})



export default router
